export function handlePreloadingOfShortcodes(shortcode: string) {
  console.log("handle preloading of shortcodes: ");
  $.ajax({
    url: shortcode_ajax.ajax_url, // This comes from wp_localize_script
    type: "POST",
    data: {
      action: "render_shortcode",
      shortcode: shortcode,
      nonce: shortcode_ajax.nonce,
    },
    success: function (response) {
      if (response.success) {
        (window as any).theShortcodeApp = {
          [response.data.wizard_id]: {
            html: response.data.html,
            wizardId: response.data.wizard_id,
          },
        };
      } else {
        console.error("Failed to render shortcode:", response.data);
      }
    },
    error: function (xhr, status, error) {
      console.error("AJAX error:", error);
    },
  });
}
